const NUMERIC_HINTS = [
  'toplam', 'total', 'totaal', 'km', 'kost', 'çalışma saati', 'werkuur', 'aantal uren', 'aantal',
  'saat ücreti', 'uurloon', 'başlangıç maliyeti', 'stops', 'ücret', 'excl btw', 'fiyat', 'maliyet',
];

// Locale-aware string→number parse
const toNumber = (v) => {
  if (typeof v === 'number') return isFinite(v) ? v : null;
  if (v === null || v === undefined || v === '') return null;
  let s = String(v).trim().replace(/[€$£\s]/g, '');
  if (s === '' || s === '-') return null;
  if (s.includes('.') && s.includes(',')) {
    s = s.lastIndexOf(',') > s.lastIndexOf('.') ? s.replace(/\./g, '').replace(',', '.') : s.replace(/,/g, '');
  } else if (s.includes(',')) {
    s = s.replace(',', '.');
  }
  const n = parseFloat(s);
  return isFinite(n) ? n : null;
};

// Tek müşteri için worksheet: numeric hücreler, AutoFilter, kolon genişliği, donmuş başlık.
export function buildRoutesSheet(XLSX, headers, rows, numericCols) {
  const isNumericCol = headers.map((h, i) => (
    Array.isArray(numericCols) ? numericCols.includes(i) : NUMERIC_HINTS.some((n) => String(h || '').toLowerCase().includes(n))
  ));
  const ws = XLSX.utils.aoa_to_sheet([headers]);
  rows.forEach((row, rIdx) => {
    headers.forEach((_, cIdx) => {
      const addr = XLSX.utils.encode_cell({ r: rIdx + 1, c: cIdx });
      const raw = row[cIdx];
      if (isNumericCol[cIdx]) {
        const n = toNumber(raw);
        ws[addr] = n === null ? { t: 's', v: '' } : { t: 'n', v: n, z: '#,##0.00' };
      } else {
        ws[addr] = { t: 's', v: raw == null ? '' : String(raw) };
      }
    });
  });
  const range = { s: { r: 0, c: 0 }, e: { r: rows.length, c: headers.length - 1 } };
  ws['!ref'] = XLSX.utils.encode_range(range);
  ws['!autofilter'] = { ref: XLSX.utils.encode_range(range) };
  ws['!cols'] = headers.map((h, i) => {
    let maxLen = String(h || '').length;
    rows.forEach((r) => { const s = r[i] == null ? '' : String(r[i]); if (s.length > maxLen) maxLen = s.length; });
    return { wch: Math.min(30, Math.max(10, maxLen + 2)) };
  });
  ws['!freeze'] = { xSplit: '0', ySplit: '1', topLeftCell: 'A2', activePane: 'bottomLeft', state: 'frozen' };
  return ws;
}
